module.exports = __webpack_public_path__ + "static/media/health-care.78148ca1.jpg";